var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animation-screen"},[_c('div',{staticClass:"animation-screen__wrapper"},_vm._l((_vm.actors),function(actor,index){return _c(actor.component,_vm._b({key:actor.id,ref:"actors",refInFor:true,tag:"component",class:actor.class,style:({
                top: actor.y + 'px',
                left: actor.x + 'px',
                transform: 'scale(' + actor.scale + ')',
                opacity: actor.opacity,
                zIndex: 1000 + index,
            })},'component',actor.componentProps,false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }